import moment from 'moment';
import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createComandFailed, createComandSuccessful } from '../actions';
import { CREATED, NO_CONTENT } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* executeComand(action) {
  try {
    const {
      id,
      command,
    } = action.payload;

    const url = `${BACKEND_URL}/hosts/${id}/actions`;
    const dataResponse = yield makeRequest(url, { command }, action, 'POST', true);
    if (dataResponse.status === CREATED) {
      yield put(createComandSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(createComandFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createComandFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
